import { useCallback, useEffect, useState } from "react";
import { UploadCloud } from "lucide-react";
import { fetchApi } from "../marketing/access";

// "Push to EHR" on the Patients, Appointments and Treatment plans screens (old
// app: components/SyncPushButton.js).
//
//   connected system and its backlog ... GET  /api/sync-keys/sync-status
//                                        { configured, listening, entities: { [entity]: { waiting } }, webhooks }
//   push ............................... POST /api/sync-keys/push { entity } → { pushed }
//
// It says push, not sync: Olli re-sends what the clinic's EHR has never
// acknowledged; it can't read an EHR. Shown only when a sync key exists
// (configured) and the EHR registered a webhook (listening), so a clinic with
// no EHR never sees a button it can't use.

/** entity: 'patients' | 'appointments' | 'care_plans'. */
export function EhrPushButton({ entity, canEdit = true }) {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");

  const load = useCallback(async () => {
    const r = await fetchApi("/api/sync-keys/sync-status");
    setState(r.ok ? r.data : null);
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!note) return undefined;
    const t = setTimeout(() => setNote(""), 6000);
    return () => clearTimeout(t);
  }, [note]);

  if (!state?.configured || !state?.listening) return null;
  const waiting = Number(state.entities?.[entity]?.waiting || 0);
  const failing = (state.webhooks || []).some((w) => Number(w.consecutive_failures) >= 3);
  const push = async () => {
    setBusy(true);
    setNote("");
    const r = await fetchApi("/api/sync-keys/push", { method: "post", body: { entity } });
    setBusy(false);
    setNote(r.ok ? (Number(r.data?.pushed) ? `Pushed ${r.data.pushed} to ${state.system || "your EHR"}` : "Nothing waiting") : r.message || "Push failed");
    load();
  };
  return <div className="flex items-center gap-2">
    {note ? <span role="status" className="text-caption text-muted">{note}</span> : <>
      {waiting > 0 && <span className="text-caption font-semibold text-warning" title={`${waiting} record${waiting === 1 ? "" : "s"} your EHR has not acknowledged`}>{waiting} waiting</span>}
      {failing && <span className="text-caption font-semibold text-danger" title="The last few webhook deliveries failed">EHR not responding</span>}
    </>}
    <button type="button" onClick={push} disabled={busy || !canEdit} title={!canEdit ? "View only. Ask an admin for edit access." : `Re-send records ${state.system || "your EHR"} has not acknowledged`} className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-full px-4 text-small font-semibold ring-1 ring-line hover:bg-mist disabled:opacity-50">
      <UploadCloud size={15} strokeWidth={1.75} />{busy ? "Pushing…" : "Push to EHR"}
    </button>
  </div>;
}
